<template>
    <div id="mainBlock">
        <div id="blackPanel"></div>
        <article>
            <div class="l-main helpPageTop">
                <div class="setting-area">
                    <ul class="setting-ul">
                        <li class="setting-li">
                            <router-link class="settingRouter" :to="'/help/details_livepro_user?site_no=' + this.$store.getters['auth/getSiteNo']">
                                <p class="setting-name">データ閲覧者向け</p>
                                <p class="setting-detail">ライブアプリケーションヘルプを表示します。</p>
                            </router-link>
                        </li>
                        <!-- managerのみ閲覧可能 -->
                        <li class="setting-li" v-if="helpDisplay">
                            <router-link class="settingRouter" :to="'/help/details_livepro_admin?site_no=' + this.$store.getters['auth/getSiteNo']">
                                <p class="setting-name">端末管理者向け</p>
                                <p class="setting-detail">ライブアプリケーションヘルプを表示します。</p>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    name: "HelpMain",
    data() {
        return {
        };
    },
    props: {
        siteInfo: {
            type: Array
        }
    },
    methods: {},
    computed: {
        /**********************************************************/
        // 権限による「端末管理者」ヘルプの表示非表示
        /**********************************************************/
        helpDisplay() {
            return this.$userRoleAuthorization("help", "helpDisplay");
        }
    },
    mounted: function() {
        //*********************************************************/
        // 画面描写後にローディングをはずす
        /**********************************************************/
        this.$emit("loadFinish");
    },
    components: {}
};
</script>
